import React, { type MouseEventHandler } from 'react';

import Icon, { type IconProps } from '#@/components/Icon';

import { StyledClickable } from './Styles';

export interface IconClickableProps {
  className?: string;
  title?: string;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLAnchorElement & HTMLButtonElement>;
  onMouseEnter?: () => void;
  tabIndex?: number;
}

const IconClickable = React.forwardRef<HTMLButtonElement, IconClickableProps & IconProps>(
  (
    { className = '', title, disabled, onClick, onMouseEnter, tabIndex, type, ...iconProps },
    ref,
  ) => (
    <StyledClickable
      data-cy-icon-clickable={type}
      className={className}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      title={title}
      disabled={disabled}
      tabIndex={tabIndex}
      ref={ref}
    >
      <Icon type={type} {...iconProps} />
    </StyledClickable>
  ),
);

IconClickable.displayName = 'IconClickable';

export default IconClickable;
